// extracted by mini-css-extract-plugin
module.exports = {"birthdayTab":"birthday_birthdayTab___2Wdn","form":"birthday_form__7uJzf"};